import { Drawer, Form } from 'antd';
import { PeriodValues } from 'features/appointment/components/InputPeriod';
import { APPOINTMENT_SOURCE_TYPE } from 'features/appointment/services/constants';
import { IAppointmentItemData, IAppointmentServiceItem, IDraftAppointmentData } from 'features/appointment/services/types/appointment';
import moment from 'moment';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { formatCurrency } from 'utils/formatCurrency';
import { momentTimezone } from 'utils/time';
import uuid from 'utils/uuid';
import AppointmentDetailModalV2, { useAppointmentDetailModalV2Ref } from './v2';
import _, { groupBy } from 'lodash';
type Props = {
  v2?: boolean;
};
type Ref = {
  open: (data: IDraftAppointmentData | null) => void;
};
const bodyStyle = { padding: 0 };
export const appointmentDetailRef = React.createRef<Ref>();
const AppointmentDetail = forwardRef<Ref, Props>(({ }, ref) => {
  const [draffData, setDraffData] = useState<IDraftAppointmentData | null>(null);
  const [form] = Form.useForm();
  const loyaltySetting = shopSelectors.data.getLoyaltySetting();
  const staffs = shopSelectors.data.staffs();
  const v2Controls = useAppointmentDetailModalV2Ref();

  const onClose = () => {
    setDraffData(null);
  };

  const calcMoneyPoint = (point: number) => {
    if (!loyaltySetting) return 0;
    return (point || 0) / loyaltySetting?.oneDollarToPoint;
  };

  useImperativeHandle(ref, () => ({
    open: (draffData) => {
      setDraffData(draffData || null);
      const extra = draffData?.data?.data as IAppointmentItemData;

      if (!extra) return;
      const date = momentTimezone(extra.startTime);
      const endTime = momentTimezone(extra.endTime);
      const duration = endTime.diff(date, 'minutes');
      const now = moment();
      const anyone = staffs.find(o => o.anyBody);
      const staffData = staffs.find(o => o.id === extra.staffId);
      const services: IAppointmentServiceItem[] = extra.services.map(o => ({
        ...o,
        uuid_local: uuid(),
        staffId: extra.staffId,
        aptStatus: extra.requestStaff ? 'request' : 'none-request',
      }));

      groupBy(extra.services, '');
      const customerList = _.chain(extra.services)
        .groupBy('tempCustomerId')
        .map((value) => {
          const firstItem = _.first(value);
          return ({
            id: firstItem?.tempCustomerId || '', name: firstItem?.customerName,
            services: value.map(s => ({
              ...s,
              uuid_local: uuid(),
              staffId: extra.staffId,
              aptStatus: extra.requestStaff ? 'request' : 'none-request',
            }))
          });
        })
        .value();

      form.setFieldsValue({
        staff: staffData || anyone || null,
        customer: {
          id: extra.customerId,
          name: extra.customerName,
          phone: extra.customerPhone,
          point: `${extra.customerPoint || 0} points = ${formatCurrency(calcMoneyPoint(extra?.customerPoint || 0))}`,
        },
        repeat: PeriodValues.NO_REPEAT,
        services,
        customerList,
        sourceType: extra.sourceType,
        note: extra.note,
        group: 1,
        date: date.clone(),
        duration,
        aptDate: date,
        numberCustomers: extra.numberCustomers,
        startTime: date.isSameOrAfter(now, 'day') ? date?.format('hh:mm A') : '',
        status: extra.status,
        aptStatus: extra.sourceType === APPOINTMENT_SOURCE_TYPE.ONLINE ? 'online' : extra.requestStaff ? 'request' : 'none-request',
      });
      setTimeout(() => {
        v2Controls.current?.init();
      }, 10);
    },
  }));

  return (
    <Drawer
      onClose={onClose} open={!!draffData}
      title={<></>}
      headerStyle={{ display: 'none' }}
      width={'auto'}
      bodyStyle={bodyStyle}
    >
      <AppointmentDetailModalV2 ref={v2Controls} form={form} data={draffData} onClose={onClose} visible={!!draffData} />
    </Drawer>
  );
});
AppointmentDetail.displayName = 'AppointmentDetailV2';
export default AppointmentDetail;
